import React from "react";

interface LogoutPopupProps {
  title?: string;
  message?: string;
  onCancel: () => void;
  onConfirm: () => void;
}

const LogoutPopup: React.FC<LogoutPopupProps> = ({
  title = "Logout",
  message = "Are you sure you want to logout?",
  onCancel,
  onConfirm,
}) => {
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
      <div
        className="
          w-[90%] max-w-[503px] h-auto
          bg-white rounded-[12px]
          shadow-[0px_6px_24px_0px_rgba(0,0,0,0.15)]
          p-[24px] flex flex-col gap-4
        "
      >
        {/* Title */}
        <h2 className="text-xl font-semibold">{title}</h2>

        <div className="w-full border-t border-1px border-gray-200 mb-4"></div>

        {/* Message */}
        <p className="text-xl font-semibold">{message}</p>

        <div className="w-full border-t border-1px border-gray-200 mt-6"></div>

        {/* Buttons */}
        <div className="flex justify-end gap-[10px]">
          <button
            onClick={onCancel}
            className="
              w-[132px] h-[46px]
              rounded-[8px]
              bg-[#0BA6C7]
              px-[14px]
              text-white
              hover:bg-[#0BA6C7]
              transition-colors
              
            "
          >
            Cancel
          </button>
          <button
            onClick={onConfirm}
            className="
             w-[132px] h-[46px]
              rounded-[8px]
              border border-[#0BA6C7]
              bg-white
              px-[14px]
              text-[#0BA6C7]
              hover:bg-gray-50
              transition-colors
            "
          >
            Yes, Logout
          </button>
        </div>
      </div>
    </div>
  );
};

export default LogoutPopup;
